import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, MonitorIcon, CreditCardIcon, ShieldCheckIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { usePricing } from '../contexts/PricingContext';
import { ContactFormPopup } from './ContactFormPopup';
export function HeroVariant73() {
  const {
    language
  } = useLanguage();
  const {
    price
  } = usePricing();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const content = {
    ru: {
      cta: 'Получить макет'
    },
    ua: {
      cta: 'Отримати макет'
    },
    en: {
      cta: 'Get a mockup'
    }
  }[language] || content.ru;
  return <>
      <section className="relative min-h-screen w-full flex flex-col items-center justify-center px-4 pt-20 pb-12 bg-white" data-id="element-981">
        <div className="max-w-6xl mx-auto text-center flex flex-col items-center" data-id="element-982">
          <h1 className="text-4xl md:text-5xl lg:text-[4.5rem] font-bold leading-[1.3] tracking-tight text-gray-900" data-id="element-983">
            Создаем уникальные сайты
            <span className="inline-flex items-center justify-center mx-3 md:mx-4 align-middle w-14 h-14 md:w-16 md:h-16 bg-gray-100 rounded-2xl border border-gray-200 shadow-sm" data-id="element-984">
              <MonitorIcon className="w-8 h-8 text-gray-700" data-id="element-985" />
            </span>
            для клиентов, нужно оплачивать
            <span className="inline-flex items-center justify-center mx-3 md:mx-4 align-middle w-14 h-14 md:w-16 md:h-16 bg-gray-100 rounded-2xl border border-gray-200 shadow-sm" data-id="element-986">
              <CreditCardIcon className="w-8 h-8 text-gray-700" data-id="element-987" />
            </span>
            только за обслуживание
            <span className="inline-flex items-center justify-center mx-3 md:mx-4 align-middle w-14 h-14 md:w-16 md:h-16 bg-gray-100 rounded-2xl border border-gray-200 shadow-sm" data-id="element-988">
              <ShieldCheckIcon className="w-8 h-8 text-gray-700" data-id="element-989" />
            </span>
            всего лишь
            <span className="inline-flex items-center justify-center mx-3 md:mx-4 align-middle px-6 py-2 bg-blue-50 border border-blue-200 text-blue-600 rounded-2xl text-3xl md:text-4xl font-black shadow-sm" data-id="element-990">
              {price}
            </span>
            в месяц
          </h1>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.4
        }} className="mt-16" data-id="element-991">
            <button onClick={() => setIsPopupOpen(true)} className="group flex items-center justify-center gap-2 rounded-2xl px-10 py-5 font-bold text-lg transition-all hover:scale-105 bg-gray-900 text-white shadow-xl" data-id="element-992">
              {content.cta}
              <ArrowRightIcon className="w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-993" />
            </button>
          </motion.div>
        </div>
      </section>
      <ContactFormPopup isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} data-id="element-994" />
    </>;
}